import Aside from "../Component/Aside";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import ProfileMhs from "../Component/ProfileMhs";

export default function FormExample() {
    return <>
        <Header />
        <Aside />
        <ProfileMhs />
        <Footer />
    </>
}